// extracted by mini-css-extract-plugin
export var actions = "pipkin-module--actions--Zo59P";
export var artwork = "pipkin-module--artwork--dvMZj";
export var back = "pipkin-module--back--SchdX";
export var component = "pipkin-module--component--lgePT";
export var container = "pipkin-module--container--7TlKe";
export var eyebrow = "pipkin-module--eyebrow--ijezG";
export var hero = "pipkin-module--hero--ElmiY";
export var introduction = "pipkin-module--introduction--GVYzR";
export var status = "pipkin-module--status--uD+bR";
export var story = "pipkin-module--story--j+du+";
export var subtitle = "pipkin-module--subtitle--P-1gk";
export var title = "pipkin-module--title--Xy4WP";